import React, { Component } from "react";
import nidhi from "../images/nidhi.png";
import "./styles.css";
class Header extends Component {
  render() {
    return (
      <div className="Header">
        <div className="titleImage" style={{ borderRadius: "50px!important" }}>
          <img
            src={nidhi}
            alt="Nidhi"
            style={{ borderRadius: "50%!important" }}
          />
        </div>
        <div className="head_title"> NIDHI KUMARI </div>

        {/* <div className="hbody">I am a frontend developer who bring ideas into life through code.</div> */}
      </div>
    );
  }
}

export default Header;
